import React from 'react';
import styled from 'styled-components';
import HvSvg from 'src/components/HvSvg';
import {
  NotificationComponentContainer,
  NotificationIconPadding,
} from './styled';

const EnableSelectToolNotificationContainer = styled.div`
  ${NotificationComponentContainer}
`;

const SelectIcon = styled.div`
  ${NotificationIconPadding}
`;

const EnableSelectText = styled.div`
  padding-right: 8px;
`;

const EnableSelectToolNotification = () => (
  <EnableSelectToolNotificationContainer data-selenium="enableSelectToolNotificationText">
    <SelectIcon>
      <HvSvg src={require('src/assets/images/ic-select-2.svg')} />
    </SelectIcon>
    <EnableSelectText>Select Tool: add or remove facades</EnableSelectText>
  </EnableSelectToolNotificationContainer>
);

export default EnableSelectToolNotification;
